import gql from 'graphql-tag';

export default gql`
  query productBySupplierInternalCode($supplierInternalCode: String!) {
    productBySupplierInternalCode(supplierInternalCode: $supplierInternalCode) {
      id
      supplier {
        id
        name
        private
      }
      supplierInternalCode
      imageUrl
      note
      origin
      preservation
      preservationLocal
      vat
      uomLocal
      uom
      price
      originalPrice
      savingAmount
      category {
        name
        nameLocal
        parent {
          name
          nameLocal
        }
      }
      name
      nameLocal {
        en
        vi
      }
      description
      isFavorite
      inStock
      tags
      details
      allowAddToCart
      private
      allowPurchase
      brand {
        id
        slug
        name
      }
      tagImageVn
      tagImageEn
    }
  }
`;
